import { taskTypes } from 'redux/redux-modules'
import { put, select } from 'redux-saga/effects'

export function* getRequestsStartSaga() {
  const startedLoadingTaskTypes = yield select(taskTypes.selectors.hasRequestStartedSelector)

  if (!startedLoadingTaskTypes) {
    yield put(taskTypes.actions.makeRequest())
  }
}
